import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table/index';
import TableBody from '@material-ui/core/TableBody/index';
import TableCell from '@material-ui/core/TableCell/index';
import TableHead from '@material-ui/core/TableHead/index';
import TableRow from '@material-ui/core/TableRow/index';
import Paper from '@material-ui/core/Paper/index';
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import ModalVentasRapidas from "./ModalVentasRapidas";
import {FieldsJs} from "../../../../settings/General/General";
import {ReactLocalStorageService} from '../../../../settings/ReactLocalStorageService/ReactLocalStorageService';
import Zoom from "@material-ui/core/Zoom";
import Tooltip from "@material-ui/core/Tooltip";
import {PopupService} from "../../../../settings/PoPup/PoPup";
import {VentasRapidasService} from "../../../../services/VentasRapidasService/VentasRapidasService";
import {CONFIG} from "../../../../settings/Config/Config";
import icon_mas from "../../../../assets/img/icons/expandir-mas.svg";
import icon_menos from "../../../../assets/img/icons/expandir-menos.svg";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";


class ListaTabla extends Component {
	
	Usr = {};
	
	constructor() {
		super();
		this.Usr = ReactLocalStorageService.get('Usr') || {};
	}
	
	eliminar = (item) => {
		let msg = `¿Deseas eliminar la venta con Id:  ${item.id_venta_rapida}?`;
		PopupService.Confirm(['Cancelar', 'Eliminar'], 'warning', CONFIG.titulo_alert_confirm, msg).then((r) => {
			if (r.button === 'Eliminar') {
				VentasRapidasService.Eliminar(item.id_venta_rapida).then((response) => {
					this.props.showSnackBars('success', response.mensaje);
					this.props.RefreshList();
				}).catch((error) => {
					this.props.showSnackBars('error', error.mensaje);
				});
			}
		});
	};
	

	
	render() {
		
		const {lista} = this.props;
		
		const bg_mas = {
			backgroundImage: `url(${icon_mas})`
		};
		
		const bg_menos = {
			backgroundImage: `url(${icon_menos})`
		};
		
		
		return (
			<Paper>
				<Table className={' desing-acresco'}>
					<TableHead>
						<TableRow>
							<TableCell component="th" align={'center'} className={'w-20-px padding-20-L padding-20-R'}/>
							<TableCell component="th" align={'left'}>Cliente</TableCell>
							<TableCell component="th" align={'center'}>Fecha</TableCell>
							<TableCell component="th" align={'center'}>Subtotal</TableCell>
							<TableCell component="th" align={'center'}>Total</TableCell>
							<TableCell component="th" align={'center'} className={'w-110-px'}>Acciones</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{lista.map((item, key) => (
							<Fragment key={key}>
								<TableRow>
									
									<TableCell align={'center'} className={'padding-20-L padding-20-R'}>
										<div style={!!item.expandir ? bg_menos : bg_mas}
										     className={'bg-img-contain-x-center-y-center h-20-px w-20-px cursor-pointer'}
										     onClick={() => this.props.ShowSubTabla(item, key)}
										/>
									</TableCell>
								
								<TableCell align={'left'}>
									{item.cliente}
								</TableCell>
								
								<TableCell align={'center'}>
									{item.fecha}
								</TableCell>
								
								<TableCell align={'center'}>
									{item.subtotal}
								</TableCell>
								
								<TableCell align={'center'}>
									{item.total}
								</TableCell>
								
								<TableCell align={'center'} className={'padding-5-L padding-5-R'}>
									
									<div className={'w-auto vertical-inline'}>
										{FieldsJs.inArray([1, 2], this.Usr.id_cat_tipo_usuario) ? (
											<div className={'v-center'}>
												<Tooltip TransitionComponent={Zoom} placement={"top"} title="Eliminar">
													<IconButton aria-label="Eliminar" onClick={() => this.eliminar(item)}>
														<DeleteOutlined/>
													</IconButton>
												</Tooltip>
											</div>
										) : ''}
										{FieldsJs.inArray([1, 2], this.Usr.id_cat_tipo_usuario) ? (
											<div className={'v-center'}>
												<ModalVentasRapidas
													id_venta_rapida={item.id_venta_rapida}
													tipo={'edit'}
													item={item}
													RefreshList={this.props.RefreshList}
													showSnackBars={this.props.showSnackBars}
												/>
											</div>
										) : ''}
										<div className={'v-center'}>
											<ModalVentasRapidas
												id_venta_rapida={item.id_venta_rapida}
												tipo={'view'}
												item={item}
												RefreshList={this.props.RefreshList}
												showSnackBars={this.props.showSnackBars}
											/>
										</div>
									</div>
								
								</TableCell>
							
							</TableRow>
								{!!item.expandir ? (
									<TableRow>
										<TableCell
											align={'center'}
											className={'padding-20-L padding-20-R padding-20-T padding-20-B'}
											colSpan={6}
										>
											
											<div className={'bg-white card-2'}>
												
												<Grid container spacing={1}>
													
													<Grid item xs={12} sm={4} md={4} lg={3} xl={3}>
													
													</Grid>
													<Grid item xs={12} sm={4} md={4} lg={6} xl={6}>
														<Typography className={'px-14 text-center bg-white padding-10'}>
															PARTIDAS
														</Typography>
													</Grid>
													<Grid item xs={12} sm={4} md={4} lg={12} xl={12}>
														
														<table width={'100%'} className={'bg-white'} style={{
															borderSpacing: "0px"
														}}>
															<thead>
															<tr>
																<th className={'text-left'}>Concepto</th>
																<th className={'text-left'}>Cantidad</th>
																<th className={'text-left'}>Precio Unitario</th>
																<th className={'text-left'}>Importe</th>
															</tr>
															</thead>
															<tbody>
															{item.partidas.map((value, index) => (
																<tr key={index}>
																	<td className={'text-left'}>{value.concepto || "-"}</td>
																	<td className={'text-left'}>{value.cantidad || "-"}</td>
																	<td className={'text-left'}>{value.precio_unitario || "-"}</td>
																	<td className={'text-left'}>{value.importe || "-"}</td>
																</tr>
															))}
															</tbody>
														</table>
													</Grid>
												</Grid>
												
											</div>
										
										</TableCell>
									</TableRow>
								) : null}
							</Fragment>
						))}
					</TableBody>
				</Table>
			</Paper>
		)
	}
}

ListaTabla.propTypes = {
	lista: PropTypes.array.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
	ShowSubTabla: PropTypes.func.isRequired,
};

export default ListaTabla;
